module.exports = __webpack_public_path__ + "static/media/spices_over_food_getty_desktop.b244de56.jpg";